export default () => ({
  rawVehicleData: [], // fetched by api, array of raw vehicle data responses
  vehicles: [] // favourite vehicles, will be saved in locale storage automatically
})
